import React, { useState } from 'react';
import { Form, Button, Container, Row, Col } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import './AdminLogin.css';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/authContext';

function AdminLogin() {
    const [credentials, setCredentials] = useState({ email: '', password: '' });
    const { updateUser } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = (event) => {
        event.preventDefault();
        const { email, password } = credentials;
        const adminEmail = 'admin@gmail.com';
        const adminPassword = 'Admin123';


        if (email === adminEmail && password === adminPassword) {
            toast.success('Login Successful!');
            updateUser(credentials);
            setTimeout(() => {
                navigate('/admin');
            }, 2000);
        } else {
            toast.error('Invalid email or password');
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setCredentials(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    return (
        <div className="d-flex vh-100 bg-gray-900" style={{
            backgroundSize: 'cover',
            backgroundPosition: 'center'
        }}>
            <Row className="m-auto align-self-center w-100 position-relative z-2">
                <Col xs={12} md={6} lg={4} className="m-auto border-none">
                    <Form onSubmit={handleSubmit} className="p-4 rounded bg-dark text-light outline-gray-900">
                        <h2 className="text-5xl mb-9 text-blue-600 font-bold text-center">Admin Login</h2>
                        <Form.Group controlId="formBasicEmail">
                            <Form.Label>Email address</Form.Label>
                            <Form.Control
                                type="email"
                                value={credentials.email}
                                placeholder="admin@gmail.com"
                                onChange={handleChange}
                                name="email"
                            />
                        </Form.Group>
                        <Form.Group controlId="formBasicPassword" className="mt-3">
                            <Form.Label>Password</Form.Label>
                            <Form.Control
                                type="password"
                                placeholder="Admin123"
                                value={credentials.password}
                                onChange={handleChange}
                                name="password"
                            />
                        </Form.Group>
                        <Button variant="primary" type="submit" className="font-bold mt-3 w-100 py-2">
                            Login
                        </Button>
                    </Form>
                </Col>
            </Row>
            <ToastContainer position="top-center" autoClose={5000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </div>
    );
}

export default AdminLogin;
